import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { clsx as cx } from 'clsx';
import * as styles from './QuestionLayoutBodyWrapper.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var QuestionLayoutBodyWrapper = function QuestionLayoutBodyWrapper(props) {
  var deviceType = useDeviceType();
  var _props$layoutType = props.layoutType,
    layoutType = _props$layoutType === void 0 ? 'default' : _props$layoutType,
    children = props.children;
  return /*#__PURE__*/_jsx("div", {
    className: cx(styles['body'], styles["body--".concat(deviceType)], styles["body--".concat(layoutType)]),
    "data-testid": "questionLayoutBodyWrapper",
    children: children
  });
};